import { MEASURED_EXERCISES_URL, REAL_TIME_DETECTION_URL } from './UrlManager';
import axios from '../../../../../src/services/Axios';
import GLOBAL from "../../../../global";
import CONSTANT from '../../../../constants/Constant';
import { error, success } from "../../../../services/ResponseHandler";
import ErrorLogService from "../../../../services/ErrorLogService";

const RESPONSE_TYPE = {responseType: "text"};

export const getMeasuredExercises = async (testId, bodyRegionList) => {
    const payload = {
        Tenant: GLOBAL.TENANT,//VA PORTAL API
        TestId: testId,
        PatientId: (GLOBAL?.USER_INFO && GLOBAL?.USER_INFO?.['ContactId']) || '',//VA PORTAL API
        BodyRegionList: bodyRegionList || [],
        SelectedExerciseType: [CONSTANT.MOVEMENT_TYPES.STRENGTH, CONSTANT.MOVEMENT_TYPES.ROM, CONSTANT.MOVEMENT_TYPES.HYBRID]
    };

    const errorPayload = ErrorLogService.createErrorLogPayload({
        Tenant: GLOBAL.TENANT || "Unknown_Tenant",
        Source: "getMeasuredExercises",
        HelpLink: "",
        DeviceInfo: navigator.userAgent || "Unknown Device",
        RequestUrl: MEASURED_EXERCISES_URL,
        TestId: testId,
        IncomingData: payload
    });

    try {
        const response = await axios.post(MEASURED_EXERCISES_URL, payload, RESPONSE_TYPE);

        // Check if response status is not 200 and log error
        if(response && response.status && response.status !== 200) {
            errorPayload.StackTrace = `HTTP ${response.status} - ${response.statusText || 'Unknown Error'}`;
            errorPayload.Message = `Get exercise list failed with status ${response.status}`;

            await ErrorLogService.logError(errorPayload, { fireAndForget: true });
        }
        return success(response);
    } catch (e) {
        // Log error for axios network errors or other exceptions
        errorPayload.StackTrace = e.stack || e.toString();
        errorPayload.Message = `Video processing failed: ${e.message || 'Unknown error'}`;

        await ErrorLogService.logError(errorPayload, { fireAndForget: true });

        return error(e);
    }
};

export const getRealTimeDetection = async (testId, selectedExerciseType) => {
    const payload = {
        Tenant: GLOBAL.TENANT,//VA PORTAL API
        TestId: testId,
        SelectedExerciseType: [...selectedExerciseType]
    };

    try {
        const response = await axios.post(REAL_TIME_DETECTION_URL, payload, RESPONSE_TYPE);
        return response;
    } catch (e) {
        return error(e);
    }
};